import { Routes } from '@angular/router';
import { AboutComponent } from './pages/about/about.component';
import { NotFoundPageComponent } from './pages/page-not-found/not-found-page.component';
import { AuthGuardService as AuthGuard } from "./services/auth-guard.service";

export const ROUTES: Routes = [

  {
    path: 'functies',
    data: {
      title: 'Ontdek 400+ Zorgfuncties | Vind jouw functie in de zorg',
      description: 'Bekijk 400+ functies in de zorg. Filter op werksoort, opleiding of salaris en vind tips voor opleidingen en doorgroeimogelijkheden in de zorg.',
      keywords: 'functies in de zorg, zorgfuncties, banen in de zorg, werken in de zorg, zorgberoepen, functies zorg, doorgroeien zorg'
    },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/functie/functie-overzicht/functie-overzicht-page.module').then(
        module => module.FunctieOverzichtPageModule
      )
  },
  {
    path: 'functie/:slug',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/functie/functie-detail/function-detail-page.module').then(
        module => module.FunctionDetailPageModule
      )
  },
  {
    path: 'test/:surveyId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/generic-test/generic-test.module').then(
        module => module.GenericTestModule
      )
  },
  {
    path: 'test-overzicht',
    data: {
      title: 'Gratis loopbaantesten in Zorginspirator',
      description: 'Doe onze tests en ontdek meer over jezelf en het werken in de Zorg! Op deze pagina van Zorginspirator vind je verschillende testen. Doe bijvoorbeeld de energiegevers test en ontdek wat jou in je werk energie geeft. Of vul de werkstijlen test in om je persoonlijke werkstijl te bepalen en te ontdekken welke functies in de zorg bij jouw werkstijlen passen.',
      keywords: 'Test jezelf in de Zorg, Loopbaantest, Zorginspirator test, persoonlijkheidstest, competentietest, beroepskeuzetest'
    },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/test/test-page.module').then(
        module => module.TestPageModule
      )
  },
  {
    path: 'opleidingen',
    data: {
      title: 'Zorgopleidingen zoeken & vergelijken | Bijscholing & Certificaten',
      description: 'Vind en vergelijk zorgopleidingen, bijscholingen en certificaten. Filter op onderwerp, niveau of vorm. Ontdek de opleiding die past bij jouw zorgcarrière.',
      keywords: 'zorgopleiding, opleiding zorg, mbo zorg certificaat, zorgsector opleidingen, specialisatie zorg, bijscholing zorgmedewerker, zorg carrièrestap, opleiding zorgloopbaan'
    },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/opleiding/opleiding-overzicht/opleiding-overzicht-page.module').then(
        module => module.OpleidingOverzichtPageModule
      )
  },
  {
    path: 'opleiding/:slug',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/opleiding/opleiding-detail/opleiding-detail-page.module').then(
        module => module.OpleidingDetailPageModule
      )
  },
  {
    path: 'opleidingopbouw',
    canActivate: [AuthGuard],
    data: {
      isChatFlow: true
    },
    loadChildren: () =>
      import('./pages/opleiding/opleiding-opbouw/opleiding-opbouw.module').then(module => module.OpleidingOpbouwModule)
  },
  {
    path: 'profiel',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/profiel/overzicht/profiel-overzicht-page.module').then(
        module => module.ProfielOverzichtPageModule
      )
  },
  {
    path: 'profielopbouw',
    canActivate: [AuthGuard],
    data: {
      isChatFlow: true
    },
    loadChildren: () =>
      import('./pages/profiel/opbouw/profiel-opbouw-page.module').then(module => module.ProfielOpbouwPageModule)
  },
  {
    path: 'profiel-print',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/profiel/print/profiel-print-page.module').then(module => module.ProfielPrintPageModule)
  },
  {
    path: 'opleiding-inspirator',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/opleiding-inspirator/opleiding-inspirator-page.module').then(
        module => module.OpleidingInspiratorPageModule
      )
  },
  {
    path: 'functietoekomstopbouw',
    canActivate: [AuthGuard],
    data: {
      isChatFlow: true
    },
    loadChildren: () =>
      import('./pages/functie/functie-toekomst-opbouw/functie-toekomst-opbouw-page.module').then(
        module => module.FunctieToekomstOpbouwPageModule
      )
  },
  {
    path: 'werkervaringopbouw',
    canActivate: [AuthGuard],
    data: {
      isChatFlow: true
    },
    loadChildren: () =>
      import('./pages/functie/functie-werkervaring-opbouw/functie-werkervaring-opbouw.module').then(
        module => module.FunctieWerkervaringOpbouwModule
      )
  },
  {
    path: 'resultaat',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/profiel/resultaat/resultaat-page.module').then(module => module.ResultaatPageModule)
  },
  {
    path: 'account-aanmaken',
    data: {
      title: 'Account aanmaken'
    },
    loadChildren: () => import('./pages/account/register/register.module').then(module => module.RegisterModule)
  },
  {
    path: 'wachtwoord-vergeten',
    data: {
      title: 'Wachtwoord vergeten'
    },
    loadChildren: () =>
      import('./pages/account/password-forgotten/password-forgotten.module').then(
        module => module.PasswordForgottenModule
      )
  },
  {
    path: 'wachtwoord-veranderen',
    data: {
      title: 'Wachtwoord veranderen'
    },
    loadChildren: () =>
      import('./pages/account/password-change/password-change.module').then(module => module.PasswordChangeModule)
  },
  {
    path: 'rekenhulp',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/rekenhulp/rekenhulp-page.module').then(module => module.RekenhulpPageModule)
  },
  {
    path: 'over-zorginspirator',
    data: {
      title: 'Over zorginspirator'
    },
    component: AboutComponent
  },
  {
    path: 'landing-test',
    loadChildren: () => import('./pages/landing-test/landing-test.module').then(module => module.LandingTestModule)
  },
  {
    path: 'info',
    data: {
      title: 'Informatie'
    },
    loadChildren: () => import('./pages/info/info-page.module').then(module => module.InfoPageModule)
  },
  {
    path: 'compare',
    loadChildren: () => import('./pages/compare/compare-page.module').then(module => module.ComparePageModule)
  },
  // {
  //   path: 'vergelijk/profiel/functie/:id',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./pages/vergelijk/profiel-functie/vergelijk-profiel-functie-page.module').then(
  //       module => module.VergelijkProfielFunctiePageModule
  //     )
  // },
  {
    path: 'pop',
    canActivate: [AuthGuard],
    data: {
      isRestricted: true,
    },
    loadChildren: () => import('./pages/pop/pop-page.module').then(module => module.PopPageModule)
  },
  {
    path: 'pop-view/:id',
    loadChildren: () => import('./pages/pop/view/pop-view-page.module').then(module => module.PopViewPageModule)
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/dashboard/dashboard-page.module').then(module => module.DashboardPageModule)
  },
  {
    path: 'dashboard/linkedin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/dashboard/dashboard-page.module').then(module => module.DashboardPageModule)
  },
  {
    path: 'dashboard/facebook',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/dashboard/dashboard-page.module').then(module => module.DashboardPageModule)
  },
  {
    path: '',
    data: {
      title: 'Zorginspirator | Werken en leren in de zorg',
      description: 'Zorginspirator, de onafhankelijke site voor jouw toekomst in de zorg. ✔ Ontdek 400+ functies ✔ Alle zorgopleidingen ✔ Tips voor jouw volgende stap',
      keywords: 'zorg, inspirator, zorginspirator, zorgsector, toekomst, functie, functies, opleiding, opleidingen, vacature, werkperspectief'
    },
    loadChildren: () => import('./pages/home/home-page.module').then(module => module.HomePageModule)
  },
  {
    path: '**',
    pathMatch: 'full',
    component: NotFoundPageComponent
  }
];
